module.exports = __webpack_public_path__ + "img/5.ebfe4463.jpg";